<nav class="lpa-modern-navbar">
  <div class="navbar-container">
    <!-- Logo Section -->
    <div class="navbar-brand">
      <div class="brand-logo">
        <img src="https://images.prismic.io/lipatinpdn/45174b3e-e9e7-4672-95bc-c554c511f14e_Logo+Liga+de+Patinaje+de+Antioquia_Mesa+de+trabajo+1.png?auto=compress,format" alt="Liga de Patinaje de Antioquia" />
      </div>
      <div class="brand-text">
        <h1 class="brand-title">Plataforma Administración</h1>
        <span class="brand-subtitle">Vinculaciones & Eventos</span>
      </div>
    </div>

    <!-- Navigation Menu -->
    <div class="navbar-menu" *ngIf="menuRol.length > 0">
      <ul class="nav-items">
        <li class="nav-item" *ngFor="let item of menuRol">
          <a [routerLink]="item.routerLink" routerLinkActive="active" class="nav-link">
            <i [class]="item.icon + ' nav-icon'"></i>
            <span class="nav-text">{{ item.label }}</span>
          </a>
        </li>
      </ul>
    </div>

    <!-- User Actions -->
    <div class="navbar-actions">
      <div *ngIf="isLogged" class="user-section">
        <div class="user-avatar">
          <i class="pi pi-user"></i>
        </div>
        <div class="user-info">
          <span class="user-name">{{ userName }}</span>
          <div class="user-menu">
            <p-menu 
              #userMenu 
              [model]="userLoggedOptions" 
              [popup]="true"
              appendTo="body"
            ></p-menu>
            <button 
              class="user-menu-trigger" 
              (click)="userMenu.toggle($event)"
              aria-label="User menu"
            >
              <i class="pi pi-angle-down"></i>
            </button>
          </div>
        </div>
      </div>
      
      <div *ngIf="!isLogged" class="login-section">
        <button 
          class="login-btn" 
          (click)="loguin($event)"
        >
          <i class="pi pi-sign-in"></i>
          <span>Iniciar Sesión</span>
        </button>
      </div>
    </div>
  </div>

  <!-- Mobile Menu Toggle -->
  <div class="mobile-menu-toggle" (click)="toggleMobileMenu()">
    <i class="pi" [ngClass]="{'pi-bars': !mobileMenuOpen, 'pi-times': mobileMenuOpen}"></i>
  </div>

  <!-- Mobile Menu Overlay -->
  <div class="mobile-menu-overlay" [class.active]="mobileMenuOpen" (click)="closeMobileMenu()">
    <div class="mobile-menu-content" (click)="$event.stopPropagation()">
      <div class="mobile-nav-items">
        <a 
          *ngFor="let item of menuRol" 
          [routerLink]="item.routerLink" 
          routerLinkActive="active" 
          class="mobile-nav-link"
          (click)="closeMobileMenu()"
        >
          <i [class]="item.icon + ' mobile-nav-icon'"></i>
          <span>{{ item.label }}</span>
        </a>
      </div>
      
      <div class="mobile-user-section" *ngIf="isLogged">
        <div class="mobile-user-info">
          <i class="pi pi-user"></i>
          <span>{{ userName }}</span>
        </div>
        <div class="mobile-user-actions">
          <button 
            *ngFor="let option of userLoggedOptions" 
            class="mobile-user-action"
            (click)="option.command && option.command($event); closeMobileMenu()"
          >
            <i [class]="option.icon"></i>
            <span>{{ option.label }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</nav>